import theme from '../../theme';
export var defaultIconProps = {
    fill: theme.primaryColours.aubergine.main,
    stroke: theme.primaryColours.aubergine.main,
};
